"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Mm = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", viewBox: "0 0 18 12", ...props },
    react_1.default.createElement("path", { fill: "#FECB00", d: "M0 0h18v6H0z" }),
    react_1.default.createElement("path", { fill: "#EA2839", d: "M0 6h18v6H0z" }),
    react_1.default.createElement("path", { fill: "#34B233", d: "M0 4h18v4H0z" }),
    react_1.default.createElement("g", { transform: "translate(9 6.422) scale(4.422)" },
        react_1.default.createElement("path", { id: "mm_svg__a", fill: "#FFF", d: "M-.325 0 0-1l.325 1z" }),
        react_1.default.createElement("use", { xlinkHref: "#mm_svg__a", transform: "rotate(-144)" }),
        react_1.default.createElement("use", { xlinkHref: "#mm_svg__a", transform: "rotate(-72)" }),
        react_1.default.createElement("use", { xlinkHref: "#mm_svg__a", transform: "rotate(72)" }),
        react_1.default.createElement("use", { xlinkHref: "#mm_svg__a", transform: "rotate(144)" }))));
exports.default = Mm;
//# sourceMappingURL=Mm.js.map